module.exports = __webpack_public_path__ + "static/media/lisa.62c4d739.webp";